import React from 'react'
import * as Item from '../item/styles'
import * as Styles from './styles'
import Icon from '../../icon'

type Props = {
  itensList: IFooterItem[]
}

export interface IFooterItem {
  text: string
  icon: string
  handleEvent?: Function
  url?: string
}

const FooterMenu: React.FC<Props> = (props: Props) => {
  function renderFooterItems(subitem) {
    return (
      <>
        <Item.Icon>
          <Icon name={subitem.icon} />
        </Item.Icon>
        <Item.Text>{subitem.text}</Item.Text>
      </>
    )
  }

  return (
    <Styles.FooterMenu>
      {props.itensList.map((subitem, key) => (
        <Item.Item key={key} onClick={() => subitem.handleEvent()}>
          {subitem.handleEvent && (
            <Styles.Content>{renderFooterItems(subitem)}</Styles.Content>
          )}
          {subitem.url && (
            <Styles.Link href={subitem.url} target={'_blank'}>
              {renderFooterItems(subitem)}
            </Styles.Link>
          )}
        </Item.Item>
      ))}
    </Styles.FooterMenu>
  )
}

export default FooterMenu
